import { render } from "./UploadPayroll.vue?vue&type=template&id=33a5aab5&scoped=true"
import script from "./UploadPayroll.vue?vue&type=script&lang=js"
export * from "./UploadPayroll.vue?vue&type=script&lang=js"

import "./UploadPayroll.vue?vue&type=style&index=0&id=33a5aab5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-33a5aab5"

export default script